import React from "react";
import moment from "moment";
import {
  List,
  Filter,
  TextField,
  Datagrid,
  SelectField,
  ChipField,
  DateInput,
  SelectInput,
  TextInput
} from "react-admin";
import { typeInvoiceLog } from "../../constant/TypeInvoiceLog";
import Actions from '../Actions'

const InvoiceFilter = props => {
  return (
    <Filter {...props}>
      <DateInput alwaysOn source="invoice_date_lte" />
      <DateInput alwaysOn source="invoice_date_gte" />
      <SelectInput source="type" choices={typeInvoiceLog} />
      <TextInput source="name_contains" />
      <TextInput source="user_email_contains" />
    </Filter>
  );
};

export const InvoiceLogList = props => {
  return (
    <List
      title="invoicelog.invoicelog"
      {...props}
      bulkActions={false}
      actions={<Actions />}
      filters={<InvoiceFilter />}
      filterDefaultValues={{
        invoice_date_gte: moment()
          .startOf("month")
          .format(),
        invoice_date_lte: moment()
          .endOf("month")
          .format()
      }}
    >
      <Datagrid>
        <div />
        <SelectField
          source="type"
          optionText={<ChipField source="name" />}
          choices={typeInvoiceLog}
        />
        <TextField source="name" />
        <TextField source="user_email" />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/invoicelog/InvoiceLogList.js